(function () {
  function initFaqHub(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';

    var input = root.querySelector('[data-faq-search]');
    var clear = root.querySelector('[data-faq-clear]');
    var status = root.querySelector('[data-faq-status]');
    var empty = root.querySelector('[data-faq-empty]');
    var categories = Array.prototype.slice.call(root.querySelectorAll('[data-faq-category]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));

    if (!input || !clear || !status || !empty || !items.length) return;

    function normalise(value) {
      return (value || '').toLocaleLowerCase().trim().replace(/\s+/g, ' ');
    }

    function filterFaqs() {
      var query = normalise(input.value);
      var visibleCount = 0;

      items.forEach(function (item) {
        var matches = !query || normalise(item.dataset.faqSearchText).indexOf(query) !== -1;
        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      categories.forEach(function (category) {
        category.hidden = !category.querySelector('[data-faq-item]:not([hidden])');
      });

      clear.hidden = !query;
      empty.hidden = visibleCount !== 0;
      status.textContent = query ? visibleCount + (visibleCount === 1 ? ' question found.' : ' questions found.') : '';
    }

    input.addEventListener('input', filterFaqs);
    clear.addEventListener('click', function () {
      input.value = '';
      filterFaqs();
      input.focus();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-faq-hub]').forEach(initFaqHub);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
